<template>
  <main class="contenedor contenido-principal pbot-0 sombra">
    <h2><span>Utilizamos los</span>mejores ingredientes</h2>
    <div class="contenido-menu">
      <div class="texto">
        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ipsam nisi amet omnis rerum veritatis in totam doloribus similique provident quas dolore ea, aperiam nesciunt blanditiis laborum cumque! Voluptatum, ea molestiae?</p>
      </div>
    </div>
  </main>
  <el-menu></el-menu>
</template>

<script>
import ElMenu from '../sections/NuestroMenu.vue';

export default {
  components: {
    ElMenu
  }
}
</script>

<style scoped>
.contenido-menu {
  background-image: url(../../assets/img/cafe.jpg);
  background-repeat: no-repeat;
  background-position: center bottom;
  background-size: 70%;
  aspect-ratio: 3/4;
  padding-bottom: 12rem;
}
@media (min-width: 500px) {
  .contenido-menu {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 5rem;
    aspect-ratio: 16/7;
    background-size: 50%;
    background-position: bottom right;
    padding-bottom: 0;
  }
}
.contenido-menu .texto {
  font-size: 2rem;
}
</style>